module.exports = __webpack_public_path__ + "img/M_document_icon@2x.a080cbf1.png";